import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

import classes from "./styles.module.scss";

const SideItem = ({ items, to, icon: Icon, collapsed, onNavigate }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { name, links } = items;

    const holdsActiveRoute = links?.some((link) => link.to === location.pathname);
    const [isOpen, setOpen] = useState(holdsActiveRoute);

    // Reveal the group that owns the current route — e.g. after a full page
    // reload, or when a page navigates the user somewhere else.
    useEffect(() => {
        if (holdsActiveRoute) setOpen(true);
    }, [holdsActiveRoute]);

    const handleGroupClick = () => {
        if (to) {
            navigate(to);
            onNavigate?.();
            return;
        }

        // A group with one destination has no submenu to reveal — the button
        // IS the link. Same on the collapsed rail, where there is no room to
        // expand anything, so it jumps to the first destination.
        if (links?.length === 1 || (collapsed && links?.length)) {
            navigate(links[0].to);
            onNavigate?.();
            return;
        }

        setOpen((prev) => !prev);
    };

    const isSingleLinkActive = links?.length === 1 && holdsActiveRoute;
    const showAsActive = to ? false : collapsed ? holdsActiveRoute : isSingleLinkActive;

    return (
        <div className={classes.group}>
            <button
                type="button"
                title={collapsed ? name : undefined}
                onClick={handleGroupClick}
                className={[
                    classes.group_button,
                    collapsed ? classes.rail : "",
                    showAsActive ? classes.active : "",
                    !collapsed && isOpen && links?.length > 1 ? classes.expanded : "",
                ]
                    .filter(Boolean)
                    .join(" ")}
            >
                {Icon ? <Icon className={classes.icon} /> : <span className={classes.icon} />}
                <span className={classes.label}>{name}</span>
                {links?.length > 1 && (
                    <ExpandMoreRoundedIcon
                        className={`${classes.chevron} ${isOpen ? classes.chevron_open : ""}`}
                    />
                )}
            </button>

            {!collapsed && isOpen && links?.length > 1 && (
                <div className={classes.submenu}>
                    {links.map((link) => (
                        <NavLink
                            key={link.to}
                            to={link.to}
                            onClick={onNavigate}
                            className={({ isActive }) =>
                                `${classes.submenu_link} ${isActive ? classes.submenu_active : ""}`
                            }
                        >
                            {link.title}
                        </NavLink>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SideItem;
